import { api, ApiRequestConfig } from './api';
import type { Suggestions, SuggestionsRequest } from '../types/suggestions';

export const getSuggestions = (props: SuggestionsRequest, config: ApiRequestConfig) =>
  api.get<Suggestions>('getSuggestions', { ...props }, config);
